import config from 'src/config';
import filePickerLib from 'lib/filepicker';

function FilePickerDirective() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, element, attrs, ngModelCtrl) => {
      element.click($event => {
        $event.preventDefault();

        filePickerLib.pick()
          .then(result => {
            const path = encodeURIComponent(result.key);

            const url = `${config.IMGIX_DOMAIN}/${path}`;

            ngModelCtrl.$setViewValue(url);

            ngModelCtrl.$dirty = true;
          });
      });
    }
  };
}

FilePickerDirective.$inject = [];

export default FilePickerDirective;



// WEBPACK FOOTER //
// ./src/directives/filePicker.js